import { Spinner } from "@ui-kitten/components";
import React, { memo } from "react";
import { ImageProps, ImageStyle, StyleSheet, View } from "react-native";

const styles = StyleSheet.create({
  spinnerContainer: {
    alignItems: "center",
    justifyContent: "center",
  },
});

const ListItemSpinnerAccessory = ({ style }: ImageProps) => {
  if (style) {
    const { height, marginHorizontal, width } = style as ImageStyle;
    return (
      <View
        style={[
          styles.spinnerContainer,
          {
            height,
            marginHorizontal,
            width,
          },
        ]}
      >
        <Spinner size="small" />
      </View>
    );
  }
  return null;
};

export default memo(ListItemSpinnerAccessory);
